import React from "react";
import { Collapse } from "antd";
import { useCanvas } from "../../context/canvasContext";
import './antSidebar.css';
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const { Panel } = Collapse;

const FramesModal = ({ isFrameModalVisible, setIsFrameModalVisible }) => {
    const { id } = useParams();
    const isMobile = window.screen.width < 768;
    const { createFrame } = useCanvas();

    const createFrameOption = (type) => {
        const frameOptions = {
            "A4": { width: 595, height: 842 }, // A4 in pixels
            "Letter": { width: 612, height: 792 }, // Letter size
            "16:9": { width: 960, height: 540 }, // 16:9 ratio
            "4:3": { width: 800, height: 600 }, // 4:3 ratio
            "1:1": { width: 600, height: 600 }, // Square
            "Custom": { width: 400, height: 300 }, // Default custom size
        };

        const frame = frameOptions[type] || frameOptions["Custom"];
        createFrame(id,{
            width: frame.width,
            height: frame.height,
            left: 100,
            top: 100,
            fill: '#fff',
            stroke: '#d8d8d8',
            strokeWidth: 2,
        });
        setIsFrameModalVisible(false);
    };

    if (!isFrameModalVisible) {
        return null;
    }

    const handleCollapseChange = (key) => {
        if (key.length === 0) {
            setIsFrameModalVisible(false);
        }
    };

    return (
        <div style={{
            width: isMobile ? '155px' : '168px',
            position: isMobile ? 'absolute' : '',
            top: isMobile ? '-290px' : '',
            right: isMobile ? "40px" : '',
            boxShadow: "rgb(101 92 92 / 50%) 0px 3px 8px",
            borderRadius: "5px",
        }}>
            <Collapse
                bordered={true}
                expandIconPosition="right"
                defaultActiveKey={['1']}
                onChange={handleCollapseChange}
            >
                <Panel
                    style={{ fontSize: isMobile ? '11px' : '13px' }}
                    header="Frames"
                    key="1"
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', cursor: 'pointer' }}>
                        {["A4", "Letter", "16:9", "4:3", "1:1", "Custom"].map((type) => (
                            <div
                                key={type}
                                onClick={() => createFrameOption(type)}
                                style={{
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '3px',
                                    textAlign: 'center',
                                    backgroundColor: '#f7f7f7',
                                }}
                            >
                                {type}
                            </div>
                        ))}
                    </div>
                </Panel>
            </Collapse>
        </div>
    );
};

export default FramesModal;
